<template>
  <div :class="['agent-report-panel', { selected: selected }]" @click.prevent="$emit('click', $event)">
    <div class="report-icon-container">
      <div class="report-icon-bg">
        <i :class="['far', report.icon]" />
      </div>
    </div>
    <div class="report-info-container">
      <div class="title">{{report.name}}</div>
      <div class="description">{{report.description}}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.agent-report-panel {
  background-color: #d3cebc;
  padding: 8px;
  border-radius: $layout-minor-border-radius;
  color: #424141;
  cursor: pointer;

  display: flex;
  flex-direction: row;
}
.report-icon-container {
  width: 40px;
}
.report-info-container {
  flex: 1;
}
.report-info-container .title {
  font-size: 14px;
  font-weight: bold;
}
.report-info-container .description {
  font-size: 10px;
  color: #888888;
}
.report-icon-bg {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background-color: #424141;
  color: #d3cebc;
  text-align: center;
  line-height: 36px;
  vertical-align: middle;
  font-size: 16px;
}
</style>

<script>
export default {
  name: 'AIReportPanel',
  props: {
    agent: Object,
    report: Object,
    selected: Boolean
  },
}
</script>